export default "__VITE_ASSET__MhuNLv33__"